import PropTypes from 'prop-types';

const PostContributingUserPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string.isRequired,
  avatar: PropTypes.string,
  createdOn: PropTypes.string,
  isAnonymous: PropTypes.bool,
  isPublicDonation: PropTypes.bool
});

export default PostContributingUserPropType;